import { LoadingScreen } from "@/components/loading-screen";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

import { useQa } from "../api/fetch-qa";

import { QaItem } from "./qa-item";

type QaListProps = {
  congressId: string;
  contentId: string;
  eventType: "SECTION" | "ABSTRACT";
};

export function QaList(props: QaListProps) {
  const { t } = useTranslation();
  const { congressId, contentId, eventType } = props;
  const {
    data: qa,
    isLoading: isQaLoading,
    isSuccess: isQaSuccess,
  } = useQa(
    {
      congressId: congressId,
      eventType: eventType,
      contentId: contentId,
    },
    {
      refetchInterval: 7000,
    },
  );

  if (isQaLoading) {
    return <LoadingScreen />;
  }

  if (!isQaSuccess) {
    return <div>{t("qa.error")}</div>;
  }

  const sortedQa = [...qa].sort((a, b) => {
    if (a.isAnswered === b.isAnswered) return 0;
    return a.isAnswered ? 1 : -1;
  });

  const flaggedQa = sortedQa.filter((qa) => qa.isFlagged);
  const unflaggedQa = sortedQa.filter((qa) => !qa.isFlagged);

  return (
    <div className="flex flex-col gap-2 py-4">
      <Card>
        <CardHeader>{t("qa.flagged")}</CardHeader>
        <CardContent>
          {flaggedQa.length > 0 ? (
            flaggedQa.map((qa) => <QaItem key={qa.id} qa={qa} />)
          ) : (
            <p className="text-sm text-muted-foreground">
              {t("qa.noFlagged")}
            </p>
          )}
        </CardContent>
      </Card>
      <Card>
        <CardHeader>{t("qa.unflagged")}</CardHeader>
        <CardContent>
          {unflaggedQa.length > 0 ? (
            unflaggedQa.map((qa) => <QaItem key={qa.id} qa={qa} />)
          ) : (
            <p className="text-sm text-muted-foreground">
              {t("qa.noUnflagged")}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
